// @ts-nocheck
import { useState } from "react";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import PictureAsPdfOutlinedIcon from "@material-ui/icons/PictureAsPdfOutlined";
import PhoneInTalkOutlinedIcon from "@material-ui/icons/PhoneInTalkOutlined";
import { format, parseISO } from "date-fns";

import { useToast } from "../../../hooks/toast";
import api from "../../../services/api";
import { CardStats } from "../styles";
import { Consultor, LaudoBox, LaudoBotao, LaudoBotaoSecundario, Status } from "./styles";

// Plano Análise, análise concluída: o laudo em PDF abre ali mesmo (rota
// autenticada, sem URL pública) e o cliente é chamado a falar com o
// consultor da venda sobre a continuação do processo.
export default function LaudoAnalise({ processo, onProcessoAtualizado }) {
  const { addToast } = useToast();
  const [abrindo, setAbrindo] = useState(false);
  const [pedindo, setPedindo] = useState(false);
  const [contatoPedido, setContatoPedido] = useState(!!processo?.analise?.continuacao?.contato_solicitado_em);

  const laudo = processo?.analise?.laudo || null;
  const consultor = processo?.analise?.consultor || null;

  const abrirLaudo = async (download = false) => {
    if (!laudo?.id) return;
    setAbrindo(true);
    try {
      const response = await api.get(`central/analise/laudos/${laudo.id}${download ? "?download=1" : ""}`, {
        responseType: "blob",
      });
      const url = window.URL.createObjectURL(response.data);
      if (download) {
        const a = document.createElement("a");
        a.href = url;
        a.download = laudo.name || "laudo-analise.pdf";
        a.click();
      } else {
        window.open(url, "_blank", "noopener");
      }
      setTimeout(() => window.URL.revokeObjectURL(url), 60000);
    } catch (err) {
      addToast({ type: "error", title: "Não foi possível abrir o laudo", description: "Tente de novo em instantes." });
    } finally {
      setAbrindo(false);
    }
  };

  // Em vez de WhatsApp: o clique registra no Pipedrive a atividade
  // "Cliente quer contato pra 2 venda" no negócio de continuação, e o
  // consultor chama o cliente.
  const pedirContato = async () => {
    setPedindo(true);
    try {
      const response = await api.post(`central/processes/${processo?.id}/analise/quero-contato`);
      const atualizado = response?.data?.data || response?.data;
      onProcessoAtualizado && onProcessoAtualizado(atualizado);
      setContatoPedido(true);
      addToast({
        type: "success",
        title: "Pedido enviado",
        description: `${primeiroNome || "Seu consultor"} vai entrar em contato com você.`,
      });
    } catch (err) {
      addToast({
        type: "error",
        title: "Não foi possível registrar o pedido",
        description: err?.response?.data?.message || "Tente de novo em instantes ou fale com o nosso suporte.",
      });
    } finally {
      setPedindo(false);
    }
  };
  const primeiroNome = consultor?.name ? consultor.name.split(" ")[0] : "";

  return (
    <CardStats>
      <p>análise concluída</p>
      <Status color="#2E5D38" iconColor="#1F9833" bgColor="#E5FFEB">
        <CheckCircleIcon />
        <p>Laudo emitido{laudo?.emitido_em ? ` em ${format(parseISO(laudo.emitido_em), "dd/MM/yyyy")}` : ""}</p>
      </Status>

      {laudo ? (
        <LaudoBox data-testid="laudo-analise">
          <div className="linha">
            <PictureAsPdfOutlinedIcon />
            <p>{laudo.name || "Laudo da análise"}{laudo.version > 1 ? ` · versão ${laudo.version}` : ""}</p>
          </div>
          <p className="texto">
            O laudo traz o resultado da análise, a situação de cada documento, os pontos de atenção e os
            próximos passos. Ele também foi enviado para o seu e-mail.
          </p>
          <LaudoBotao type="button" onClick={() => abrirLaudo(false)} disabled={abrindo}>
            <PictureAsPdfOutlinedIcon />
            {abrindo ? "Abrindo..." : "Ver o laudo"}
          </LaudoBotao>
          <LaudoBotaoSecundario type="button" onClick={() => abrirLaudo(true)} disabled={abrindo}>
            Baixar o PDF
          </LaudoBotaoSecundario>
        </LaudoBox>
      ) : (
        <p className="analysisText">O laudo está sendo preparado e aparece aqui assim que for emitido.</p>
      )}

      {processo?.analise?.continuacao?.venda_id ? (
        <Consultor data-testid="continuacao-criada">
          <strong>Continuação em andamento</strong>
          <p>
            {primeiroNome || "Seu consultor"} já montou a venda de continuação {processo.analise.continuacao.venda_client_id ? ` (${processo.analise.continuacao.venda_client_id})` : ""}
            {processo.analise.continuacao.abatimento ? ` com R$ ${(processo.analise.continuacao.abatimento / 100).toLocaleString("pt-BR", { minimumFractionDigits: 2 })} da análise abatidos` : ""}.
            O contrato e o pagamento chegam por e-mail; depois, o novo pedido aparece aqui na Central.
          </p>
          {consultor?.email && <span>{consultor.email}</span>}
        </Consultor>
      ) : (
      <Consultor data-testid="consultor-analise">
        <strong>Quer seguir com o processo?</strong>
        <p>
          {consultor?.name
            ? `Fale com ${consultor.name}, o consultor que fez a sua venda: ele explica a continuação e o abatimento do valor da análise.`
            : "Fale com o seu consultor: ele explica a continuação e o abatimento do valor da análise."}
        </p>
        {contatoPedido ? (
          <p className="confirmado" data-testid="contato-pedido">
            <CheckCircleIcon /> Pedido enviado: {primeiroNome || "seu consultor"} vai entrar em contato com você.
          </p>
        ) : (
          <button type="button" onClick={pedirContato} disabled={pedindo} data-testid="quero-contato">
            <PhoneInTalkOutlinedIcon />
            {pedindo ? "Enviando..." : `Quero falar com ${primeiroNome || "o consultor"}`}
          </button>
        )}
        {consultor?.email && <span>{consultor.email}</span>}
      </Consultor>
      )}
    </CardStats>
  );
}
